// Mock data for Löwenherz Invest AG

export const translations = {
  de: {
    nav: {
      home: 'Home',
      about: 'Über Uns',
      shares: 'Aktien',
      projects: 'Projekte',
      investors: 'Investoren',
      downloads: 'Downloads',
      contact: 'Kontakt'
    },
    hero: {
      title: 'Investieren Sie in',
      titleHighlight: 'Rendite-Immobilien',
      subtitle: 'Löwenherz Invest AG - Ihr Partner für nachhaltige Immobilieninvestitionen in der Schweiz. Handel, Vermietung und exklusive Investmentmöglichkeiten.',
      ctaPrimary: 'Jetzt Investieren',
      ctaSecondary: 'Mehr Erfahren'
    },
    services: {
      title: 'Unsere Dienstleistungen',
      subtitle: 'Umfassende Immobilienlösungen für Ihren Erfolg',
      trading: {
        title: 'Immobilienhandel',
        description: 'Professioneller An- und Verkauf von Immobilien und Grundstücken mit fundierter Marktanalyse'
      },
      rental: {
        title: 'Vermietung & Verpachtung',
        description: 'Langfristige Vermietungs- und Verpachtungslösungen für optimale Renditen'
      },
      investment: {
        title: 'Investorenbeteiligung',
        description: 'Beteiligen Sie sich durch Aktienzeichnung an unseren erfolgreichen Immobilienprojekten'
      }
    },
    projects: {
      title: 'Aktuelle Projekte',
      subtitle: 'Entdecken Sie unsere Premium-Immobilienprojekte',
      viewDetails: 'Details ansehen',
      project1: {
        title: 'Luxus Residenz Zürich',
        location: 'Zürich, Schweiz',
        type: 'Wohnimmobilie',
        status: 'In Planung'
      },
      project2: {
        title: 'Business Tower Genf',
        location: 'Genf, Schweiz',
        type: 'Gewerbeimmobilie',
        status: 'Verfügbar'
      },
      project3: {
        title: 'Moderne Villa Luzern',
        location: 'Luzern, Schweiz',
        type: 'Wohnimmobilie',
        status: 'Verkauft'
      },
      project4: {
        title: 'Innovation Hub Basel',
        location: 'Basel, Schweiz',
        type: 'Mixed-Use',
        status: 'In Entwicklung'
      }
    },
    investors: {
      title: 'Investor Relations',
      subtitle: 'Werden Sie Teil unserer Erfolgsgeschichte',
      benefits: {
        title: 'Ihre Vorteile',
        benefit1: 'Attraktive Renditen',
        benefit1Desc: 'Partizipieren Sie an erfolgreichen Immobilienprojekten',
        benefit2: 'Transparenz',
        benefit2Desc: 'Vollständige Einsicht über unser digitales Aktienregister',
        benefit3: 'Sicherheit',
        benefit3Desc: 'Investitionen in erstklassige Schweizer Immobilien'
      },
      cta: 'Investorenkonto erstellen',
      login: 'Bereits registriert? Anmelden',
      registerTitle: 'Investorenkonto erstellen',
      loginTitle: 'Investor Login',
      form: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'E-Mail',
        phone: 'Telefon',
        password: 'Passwort',
        confirmPassword: 'Passwort bestätigen',
        investment: 'Investitionsbetrag (CHF)',
        terms: 'Ich akzeptiere die Nutzungsbedingungen',
        submit: 'Konto erstellen',
        submitLogin: 'Anmelden',
        noAccount: 'Noch kein Konto? Registrieren'
      }
    },
    contact: {
      title: 'Kontaktieren Sie uns',
      subtitle: 'Wir freuen uns auf Ihre Nachricht',
      form: {
        name: 'Name',
        email: 'E-Mail',
        subject: 'Betreff',
        message: 'Nachricht',
        submit: 'Nachricht senden'
      },
      info: {
        address: 'Adresse',
        addressValue: 'Wildenstrasse 3, 8212 Neuhausen am Rheinfall, Schweiz',
        phone: 'Telefon',
        phoneValue: '+41 52 55 101 40',
        email: 'E-Mail',
        emailValue: 'office@loewenherz.ag'
      }
    },
    footer: {
      about: 'Über Löwenherz',
      aboutText: 'Löwenherz Invest AG ist Ihr verlässlicher Partner für Premium-Immobilieninvestitionen in der Schweiz.',
      quickLinks: 'Quick Links',
      legal: 'Rechtliches',
      privacy: 'Datenschutz',
      terms: 'AGB',
      imprint: 'Impressum',
      rights: '© 2025 Löwenherz Invest AG. Alle Rechte vorbehalten.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      shares: 'Shares',
      projects: 'Projects',
      investors: 'Investors',
      downloads: 'Downloads',
      contact: 'Contact'
    },
    hero: {
      title: 'Invest in',
      titleHighlight: 'Yield Real Estate',
      subtitle: 'Löwenherz Invest AG - Your partner for sustainable real estate investments in Switzerland. Trading, rental, and exclusive investment opportunities.',
      ctaPrimary: 'Invest Now',
      ctaSecondary: 'Learn More'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive real estate solutions for your success',
      trading: {
        title: 'Real Estate Trading',
        description: 'Professional buying and selling of properties and land with in-depth market analysis'
      },
      rental: {
        title: 'Rental & Leasing',
        description: 'Long-term rental and leasing solutions for optimal returns'
      },
      investment: {
        title: 'Investor Participation',
        description: 'Participate in our successful real estate projects through share subscription'
      }
    },
    projects: {
      title: 'Current Projects',
      subtitle: 'Discover our premium real estate projects',
      viewDetails: 'View Details',
      project1: {
        title: 'Luxury Residence Zurich',
        location: 'Zurich, Switzerland',
        type: 'Residential',
        status: 'In Planning'
      },
      project2: {
        title: 'Business Tower Geneva',
        location: 'Geneva, Switzerland',
        type: 'Commercial',
        status: 'Available'
      },
      project3: {
        title: 'Modern Villa Lucerne',
        location: 'Lucerne, Switzerland',
        type: 'Residential',
        status: 'Sold'
      },
      project4: {
        title: 'Innovation Hub Basel',
        location: 'Basel, Switzerland',
        type: 'Mixed-Use',
        status: 'In Development'
      }
    },
    investors: {
      title: 'Investor Relations',
      subtitle: 'Become part of our success story',
      benefits: {
        title: 'Your Benefits',
        benefit1: 'Attractive Returns',
        benefit1Desc: 'Participate in successful real estate projects',
        benefit2: 'Transparency',
        benefit2Desc: 'Full insight through our digital share register',
        benefit3: 'Security',
        benefit3Desc: 'Investments in first-class Swiss real estate'
      },
      cta: 'Create Investor Account',
      login: 'Already registered? Login',
      registerTitle: 'Create Investor Account',
      loginTitle: 'Investor Login',
      form: {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phone: 'Phone',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        investment: 'Investment Amount (CHF)',
        terms: 'I accept the terms and conditions',
        submit: 'Create Account',
        submitLogin: 'Login',
        noAccount: 'No account yet? Register'
      }
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We look forward to hearing from you',
      form: {
        name: 'Name',
        email: 'Email',
        subject: 'Subject',
        message: 'Message',
        submit: 'Send Message'
      },
      info: {
        address: 'Address',
        addressValue: 'Wildenstrasse 3, 8212 Neuhausen am Rheinfall, Switzerland',
        phone: 'Phone',
        phoneValue: '+41 52 55 101 40',
        email: 'Email',
        emailValue: 'office@loewenherz.ag'
      }
    },
    footer: {
      about: 'About Löwenherz',
      aboutText: 'Löwenherz Invest AG is your reliable partner for premium real estate investments in Switzerland.',
      quickLinks: 'Quick Links',
      legal: 'Legal',
      privacy: 'Privacy',
      terms: 'Terms',
      imprint: 'Imprint',
      rights: '© 2025 Löwenherz Invest AG. All rights reserved.'
    }
  },
  ru: {
    nav: {
      home: 'Главная',
      about: 'О нас',
      shares: 'Акции',
      projects: 'Проекты',
      investors: 'Инвесторы',
      downloads: 'Загрузки',
      contact: 'Контакты'
    },
    hero: {
      title: 'Инвестируйте в',
      titleHighlight: 'доходную недвижимость',
      subtitle: 'Löwenherz Invest AG — ваш партнёр для устойчивых инвестиций в швейцарскую недвижимость. Торговля, аренда и эксклюзивные инвестиционные возможности.',
      ctaPrimary: 'Инвестировать сейчас',
      ctaSecondary: 'Узнать больше'
    },
    services: {
      title: 'Наши услуги',
      subtitle: 'Комплексные решения в сфере недвижимости для вашего успеха',
      trading: {
        title: 'Торговля недвижимостью',
        description: 'Профессиональная купля-продажа объектов и земельных участков с глубоким анализом рынка'
      },
      rental: {
        title: 'Аренда и сдача',
        description: 'Долгосрочные решения по аренде и сдаче для оптимальной доходности'
      },
      investment: {
        title: 'Участие инвесторов',
        description: 'Участвуйте в наших успешных проектах путём подписки на акции'
      }
    },
    projects: {
      title: 'Текущие проекты',
      subtitle: 'Откройте для себя наши премиальные проекты недвижимости',
      viewDetails: 'Подробнее',
      project1: {
        title: 'Люкс-резиденция Цюрих',
        location: 'Цюрих, Швейцария',
        type: 'Жилая',
        status: 'В планировании'
      },
      project2: {
        title: 'Бизнес-башня Женева',
        location: 'Женева, Швейцария',
        type: 'Коммерческая',
        status: 'Доступно'
      },
      project3: {
        title: 'Современная вилла Люцерн',
        location: 'Люцерн, Швейцария',
        type: 'Жилая',
        status: 'Продано'
      },
      project4: {
        title: 'Инновационный центр Базель',
        location: 'Базель, Швейцария',
        type: 'Многофункциональная',
        status: 'В разработке'
      }
    },
    investors: {
      title: 'Отношения с инвесторами',
      subtitle: 'Станьте частью нашей истории успеха',
      benefits: {
        title: 'Ваши преимущества',
        benefit1: 'Привлекательная доходность',
        benefit1Desc: 'Участвуйте в успешных проектах недвижимости',
        benefit2: 'Прозрачность',
        benefit2Desc: 'Полный доступ через цифровой реестр акций',
        benefit3: 'Безопасность',
        benefit3Desc: 'Инвестиции в первоклассную швейцарскую недвижимость'
      },
      cta: 'Создать инвесторский счёт',
      login: 'Уже зарегистрированы? Войти',
      registerTitle: 'Создать инвесторский счёт',
      loginTitle: 'Вход для инвесторов',
      form: {
        firstName: 'Имя',
        lastName: 'Фамилия',
        email: 'Email',
        phone: 'Телефон',
        password: 'Пароль',
        confirmPassword: 'Подтвердите пароль',
        investment: 'Сумма инвестиций (CHF)',
        terms: 'Я принимаю условия использования',
        submit: 'Создать счёт',
        submitLogin: 'Войти',
        noAccount: 'Ещё нет аккаунта? Зарегистрироваться'
      }
    },
    contact: {
      title: 'Свяжитесь с нами',
      subtitle: 'Мы будем рады вашему сообщению',
      form: {
        name: 'Имя',
        email: 'Email',
        subject: 'Тема',
        message: 'Сообщение',
        submit: 'Отправить сообщение'
      },
      info: {
        address: 'Адрес',
        addressValue: 'Wildenstrasse 3, 8212 Нойхаузен-на-Рейнфалле, Швейцария',
        phone: 'Телефон',
        phoneValue: '+41 52 55 101 40',
        email: 'Email',
        emailValue: 'office@loewenherz.ag'
      }
    },
    footer: {
      about: 'О Löwenherz',
      aboutText: 'Löwenherz Invest AG — ваш надёжный партнёр для премиальных инвестиций в недвижимость в Швейцарии.',
      quickLinks: 'Быстрые ссылки',
      legal: 'Правовая информация',
      privacy: 'Конфиденциальность',
      terms: 'Условия',
      imprint: 'Выходные данные',
      rights: '© 2025 Löwenherz Invest AG. Все права защищены.'
    }
  },
  vi: {
    nav: {
      home: 'Trang chủ',
      about: 'Giới thiệu',
      shares: 'Cổ phiếu',
      projects: 'Dự án',
      investors: 'Nhà đầu tư',
      downloads: 'Tải xuống',
      contact: 'Liên hệ'
    },
    hero: {
      title: 'Đầu tư vào',
      titleHighlight: 'Bất động sản sinh lời',
      subtitle: 'Löwenherz Invest AG — Đối tác tin cậy của bạn cho các khoản đầu tư bất động sản bền vững tại Thụy Sĩ. Giao dịch, cho thuê và cơ hội đầu tư độc quyền.',
      ctaPrimary: 'Đầu tư ngay',
      ctaSecondary: 'Tìm hiểu thêm'
    },
    services: {
      title: 'Dịch vụ của chúng tôi',
      subtitle: 'Giải pháp bất động sản toàn diện cho thành công của bạn',
      trading: {
        title: 'Giao dịch bất động sản',
        description: 'Mua bán chuyên nghiệp bất động sản và đất đai với phân tích thị trường chuyên sâu'
      },
      rental: {
        title: 'Cho thuê & cho thuê dài hạn',
        description: 'Giải pháp cho thuê dài hạn để tối ưu hóa lợi nhuận'
      },
      investment: {
        title: 'Đầu tư cùng nhà đầu tư',
        description: 'Tham gia vào các dự án bất động sản thành công của chúng tôi qua việc đăng ký cổ phiếu'
      }
    },
    projects: {
      title: 'Dự án hiện tại',
      subtitle: 'Khám phá các dự án bất động sản cao cấp của chúng tôi',
      viewDetails: 'Xem chi tiết',
      project1: {
        title: 'Khu dân cư Luxury Zurich',
        location: 'Zurich, Thụy Sĩ',
        type: 'Nhà ở',
        status: 'Đang lập kế hoạch'
      },
      project2: {
        title: 'Tòa văn phòng Geneva',
        location: 'Geneva, Thụy Sĩ',
        type: 'Thương mại',
        status: 'Có sẵn'
      },
      project3: {
        title: 'Biệt thự Lucerne',
        location: 'Lucerne, Thụy Sĩ',
        type: 'Nhà ở',
        status: 'Đã bán'
      },
      project4: {
        title: 'Trung tâm Đổi mới Basel',
        location: 'Basel, Thụy Sĩ',
        type: 'Hỗn hợp',
        status: 'Đang phát triển'
      }
    },
    investors: {
      title: 'Quan hệ nhà đầu tư',
      subtitle: 'Trở thành một phần trong câu chuyện thành công của chúng tôi',
      benefits: {
        title: 'Lợi ích của bạn',
        benefit1: 'Lợi nhuận hấp dẫn',
        benefit1Desc: 'Tham gia vào các dự án bất động sản thành công',
        benefit2: 'Minh bạch',
        benefit2Desc: 'Toàn quyền tra cứu qua sổ đăng ký cổ đông kỹ thuật số',
        benefit3: 'An toàn',
        benefit3Desc: 'Đầu tư vào bất động sản Thụy Sĩ hạng nhất'
      },
      cta: 'Tạo tài khoản nhà đầu tư',
      login: 'Đã đăng ký? Đăng nhập',
      registerTitle: 'Tạo tài khoản nhà đầu tư',
      loginTitle: 'Đăng nhập nhà đầu tư',
      form: {
        firstName: 'Tên',
        lastName: 'Họ',
        email: 'Email',
        phone: 'Điện thoại',
        password: 'Mật khẩu',
        confirmPassword: 'Xác nhận mật khẩu',
        investment: 'Số tiền đầu tư (CHF)',
        terms: 'Tôi chấp nhận các điều khoản sử dụng',
        submit: 'Tạo tài khoản',
        submitLogin: 'Đăng nhập',
        noAccount: 'Chưa có tài khoản? Đăng ký'
      }
    },
    contact: {
      title: 'Liên hệ với chúng tôi',
      subtitle: 'Chúng tôi mong nhận được tin từ bạn',
      form: {
        name: 'Tên',
        email: 'Email',
        subject: 'Tiêu đề',
        message: 'Tin nhắn',
        submit: 'Gửi tin nhắn'
      },
      info: {
        address: 'Địa chỉ',
        addressValue: 'Wildenstrasse 3, 8212 Neuhausen am Rheinfall, Thụy Sĩ',
        phone: 'Điện thoại',
        phoneValue: '+41 52 55 101 40',
        email: 'Email',
        emailValue: 'office@loewenherz.ag'
      }
    },
    footer: {
      about: 'Về Löwenherz',
      aboutText: 'Löwenherz Invest AG là đối tác đáng tin cậy của bạn cho các khoản đầu tư bất động sản cao cấp tại Thụy Sĩ.',
      quickLinks: 'Liên kết nhanh',
      legal: 'Pháp lý',
      privacy: 'Bảo mật',
      terms: 'Điều khoản',
      imprint: 'Thông tin xuất bản',
      rights: '© 2025 Löwenherz Invest AG. Đã đăng ký bản quyền.'
    }
  }
};

export const projects = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1531971589569-0d9370cbe1e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc3ODMyODIzN3ww&ixlib=rb-4.1.0&q=85',
    titleKey: 'project1',
    roi: '8.5%'
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1574848296471-28f79a036f79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc4MzI4MjM3fDA&ixlib=rb-4.1.0&q=85',
    titleKey: 'project2',
    roi: '9.2%'
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc3ODMyODIzN3ww&ixlib=rb-4.1.0&q=85',
    titleKey: 'project3',
    roi: '7.8%'
  },
  {
    id: 4,
    image: 'https://images.pexels.com/photos/18613224/pexels-photo-18613224.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    titleKey: 'project4',
    roi: '10.1%'
  }
];

// Mock user data stored in localStorage
export const mockLogin = (email, password) => {
  const users = JSON.parse(localStorage.getItem('loewenherz_users') || '[]');
  const user = users.find(u => u.email === email && u.password === password);
  
  if (user) {
    localStorage.setItem('loewenherz_currentUser', JSON.stringify(user));
    return { success: true, user };
  }
  return { success: false, message: 'Invalid credentials' };
};

export const mockRegister = (userData) => {
  const users = JSON.parse(localStorage.getItem('loewenherz_users') || '[]');
  
  // Check if email already exists
  if (users.find(u => u.email === userData.email)) {
    return { success: false, message: 'Email already registered' };
  }
  
  const newUser = {
    id: Date.now(),
    ...userData,
    createdAt: new Date().toISOString()
  };
  
  users.push(newUser);
  localStorage.setItem('loewenherz_users', JSON.stringify(users));
  localStorage.setItem('loewenherz_currentUser', JSON.stringify(newUser));
  
  return { success: true, user: newUser };
};

export const mockLogout = () => {
  localStorage.removeItem('loewenherz_currentUser');
};

export const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('loewenherz_currentUser') || 'null');
};

export const mockContactSubmit = (data) => {
  console.log('Contact form submitted:', data);
  return { success: true, message: 'Message sent successfully' };
};